var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { FelaComponent, Container, FlexGrid } from '@filou/core';
import cloudinary from '../cloudinary';
var Reveal = require('react-reveal/Reveal');
var ruleItem = function (_a) {
    var theme = _a.theme, subtitle = _a.subtitle, background = _a.background;
    return ({
        // color: theme.dark,
        color: 'inherit',
        textDecoration: 'none',
        backgroundColor: background,
        '> h3': {
            paddingX: background ? 5 : 0,
            margin: 0,
            marginBottom: subtitle ? 5 : 20,
            fontWeight: 300
        },
        '> h4': {
            paddingX: background ? 5 : 0,
            margin: 0,
            marginBottom: 20,
            opacity: 0.8,
            fontWeight: 300
        }
    });
};
var Item = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.subtitle, subtitle = _c === void 0 ? '' : _c, children = _a.children, _d = _a.img, img = _d === void 0 ? '' : _d, size = _a.size, gridSize = _a.gridSize, render = _a.render, gutter = _a.gutter, _e = _a.background, background = _e === void 0 ? '' : _e, className = _a.className, rest = __rest(_a, ["title", "subtitle", "children", "img", "size", "gridSize", "render", "gutter", "background", "className"]);
    var childs = (React.createElement(React.Fragment, null,
        img && React.createElement("img", { width: "100%", height: "auto", src: img }),
        title && React.createElement("h3", null, title),
        subtitle && React.createElement("h4", null, subtitle),
        children));
    var Element = render || 'div';
    return (React.createElement(FelaComponent, { rule: ruleItem, background: background, subtitle: subtitle, className: className, render: function (_a) {
            var className = _a.className;
            return (React.createElement(FlexGrid.Item, __assign({ gridSize: gridSize, gutter: gutter, size: size, render: function (_a) {
                    var className = _a.className;
                    return (React.createElement(Element, { className: className }, childs));
                }, className: className }, rest)));
        } }));
};
var ruleGrid = function (_a) {
    var theme = _a.theme, background = _a.background, padding = _a.padding, alignTitle = _a.alignTitle, align = _a.align, subtitle = _a.subtitle, titleColor = _a.titleColor, alignText = _a.alignText;
    var isDark = background && ['banner', 'color', 'dark'].indexOf(background) !== -1;
    titleColor =
        (titleColor === true ? theme.color : theme[titleColor + '']) ||
            (isDark ? theme.light : theme.dark);
    return {
        backgroundColor: theme[background + ''] || undefined,
        padding: padding,
        position: 'relative',
        overflow: 'hidden',
        color: isDark ? theme.light : theme.dark,
        transition: "all 500ms cubic-bezier(0.165, 0.84, 0.44, 1)",
        extend: [
            {
                condition: background === 'banner',
                style: {
                    background: "url(" + cloudinary('/banner.jpg') + ") no-repeat center center",
                    backgroundSize: 'cover!important'
                }
            }
        ],
        '& [data-scroll-anchor]': {
            position: 'absolute',
            top: -45
        },
        '& .grid-h2': {
            fontSize: '3em',
            textAlign: (alignTitle || align) !== 'left' ? alignTitle || align : undefined,
            color: titleColor,
            margin: 0,
            marginBottom: subtitle ? 0 : 20,
            fontWeight: 300
        },
        '& .grid-h3': {
            fontSize: '2em',
            textAlign: (alignTitle || align) !== 'left' ? alignTitle || align : undefined,
            color: titleColor,
            opacity: 0.8,
            margin: 0,
            marginBottom: 40,
            fontWeight: 300
        },
        '> div > div > div': {
            textAlign: (alignText || align) !== 'left' ? alignText || align : undefined
        }
    };
};
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.render = function () {
        var _a = this.props, children = _a.children, size = _a.size, _b = _a.padding, padding = _b === void 0 ? '3em 0' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.subtitle, subtitle = _d === void 0 ? '' : _d, _e = _a.background, background = _e === void 0 ? '' : _e, _f = _a.id, id = _f === void 0 ? '' : _f, elements = _a.elements, _g = _a.verticalGutter, verticalGutter = _g === void 0 ? 0 : _g, alignTitle = _a.alignTitle, alignText = _a.alignText, align = _a.align, className = _a.className, titleColor = _a.titleColor, _h = _a.container, container = _h === void 0 ? true : _h, rest = __rest(_a, ["children", "size", "padding", "title", "subtitle", "background", "id", "elements", "verticalGutter", "alignTitle", "alignText", "align", "className", "titleColor", "container"]);
        var childs = (React.createElement(React.Fragment, null,
            id && React.createElement("span", { "data-scroll-anchor": true, id: id }),
            title && React.createElement("h2", { className: "grid-h2" }, title),
            subtitle && React.createElement("h3", { className: "grid-h3" }, subtitle),
            React.createElement(FlexGrid, __assign({}, rest, { gutter: 2, size: size, verticalGutter: verticalGutter }), children)));
        return (React.createElement(Reveal, { effect: "fadeInUp" },
            React.createElement(FelaComponent, { className: className, background: background, padding: padding, alignTitle: alignTitle, align: align, subtitle: subtitle, alignText: alignText, titleColor: titleColor, rule: ruleGrid },
                elements,
                container ? React.createElement(Container, null, childs) : childs)));
    };
    Grid.Item = Item;
    return Grid;
}(React.Component));
export default Grid;
//# sourceMappingURL=index.js.map